import { render, staticRenderFns } from "./LmSendOTP.vue?vue&type=template&id=0f761fbe&scoped=true"
import script from "./LmSendOTP.vue?vue&type=script&lang=js"
export * from "./LmSendOTP.vue?vue&type=script&lang=js"
import style0 from "./LmSendOTP.vue?vue&type=style&index=0&id=0f761fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f761fbe",
  null
  
)

export default component.exports